import React, { useMemo } from "react";
import { Grid, Box } from "@material-ui/core";
import moment from "moment-timezone";
import clsx from "clsx";
import { useStyles } from "./styles";
import { BrowserQRCodeSvgWriter } from '@zxing/browser';
import { EncodeHintType } from '@zxing/library';

const formatDt = (dt) => moment(dt).format("MM/DD/YY, LT");

const formatStatus = (status) => {
  switch (status) {
    case 0: return "Unset";
    case 1: return "In";
    case 2: return "Out";
    case 3: return "Neutral";
    default: return "";
  }
};

const OnePassDetails = ({ ticketId, validFrom, validTo, status, facilityName, name, room }) => {
  const classes = useStyles();

  const codeWriter = useMemo(() => new BrowserQRCodeSvgWriter(), []);
  const hints = useMemo(() => {
    const map = new Map();
    map.set(EncodeHintType.MARGIN, 5);
    return map;
  }, []);

  const svgHtml = useMemo(() => {
    const svgElement = codeWriter.write(ticketId, 200, 200, hints);
    return svgElement.outerHTML;
  }, [codeWriter, hints, ticketId]);

  const trimmedName = name?.trim();
  const trimmedRoom = room?.trim();
  const hasNameOrRoom = trimmedName || trimmedRoom;

  return (
    <Grid container direction="column" alignItems="center" spacing={2} className={classes.centeredContainer}>
      <Grid item>
        <div className={clsx(classes.qrcode, "ticket-id")} dangerouslySetInnerHTML={{__html: svgHtml }}></div>
      </Grid>

      <Grid item xs={12} className={clsx(classes.typeContainer, classes.typeContainerNoMarginBottom)}>
        <Box className={classes.typeLabel}>Type: </Box>
        <Box className={classes.typeValue}>ONE Pass</Box>
      </Grid>

      <Grid item xs={12} className={clsx(classes.typeContainer, classes.typeContainerNoMarginTop)}>
        <Box className={classes.typeLabel}>Status: </Box>
        <Box className={classes.typeValue}>{formatStatus(status)}</Box>
      </Grid>

      <Grid item xs={12} className={classes.datesRow}>
        <Box className={classes.validFromContainer}>
          <Box className={classes.fieldLabel}>Valid From</Box>
          <Box className={classes.fieldValue}>{formatDt(validFrom)}</Box>
        </Box>
        <Box className={classes.validToContainer}>
          <Box className={classes.fieldLabel}>Valid To</Box>
          <Box className={classes.fieldValue}>{formatDt(validTo)}</Box>
        </Box>
      </Grid>

      {hasNameOrRoom ? (
        <Grid item xs={12} className={classes.nameRoomRow}>
          {trimmedName && (
            <Box className={classes.nameContainer}>
              <Box className={classes.fieldLabel}>Name</Box>
              <Box className={classes.fieldValue}>{name}</Box>
            </Box>
          )}
          {trimmedRoom && (
            <Box className={classes.roomContainer}>
              <Box className={classes.fieldLabel}>Room</Box>
              <Box className={classes.fieldValue}>{room}</Box>
            </Box>
          )}
        </Grid>
      ) : null}
    </Grid>
  );
};

export default OnePassDetails;
